import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Output,
} from '@angular/core';
import { MobileOverlayCardComponent } from '@prlw/common/mobile-overlay-card/mobile-overlay-card.component';
import { Observable } from 'rxjs';
import { TextTagOtpComponent } from '../text-tag-otp/text-tag-otp.component';
import { MOBILE_OVERLAY_DATA_TOKEN } from '@prlw/libs/mobile-overlay/mobile-overlay.service';

export type TBasisInfoMobileItem = {
  basisCode: string;
  basisName: string;
  plantName: string;
  station: string;
  instrumentCode: string;
  instrumentName: string;
};

@Component({
  selector: 'prlw-basis-info-mobile',
  standalone: true,
  imports: [CommonModule, MobileOverlayCardComponent, TextTagOtpComponent],
  templateUrl: './basis-info-mobile.component.html',
  styleUrl: './basis-info-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisInfoMobileComponent {
  @Output() eventClose = new EventEmitter<void>();

  constructor(
    @Inject(MOBILE_OVERLAY_DATA_TOKEN)
    public item$: Observable<TBasisInfoMobileItem>,
  ) {}
}
